module.exports = __webpack_public_path__ + "6c5c739cade75797729e0b799693da6c.fbx";